import { SortingTypes } from "../../helpers/SortingTypes";
import { Flex, TriangleDownIcon, TriangleUpIcon } from "@chakra-ui/icons";


interface SortIconProps {
  sort: SortingTypes | boolean | null | undefined;
}

export function SortIcon(props: SortIconProps) {
  return (
    <Flex flexDirection="column">
      <TriangleUpIcon w="10px" h="10px" sx={{
        opacity: props.sort === SortingTypes.DESC ? 0.6 : 1
      }} />
      <TriangleDownIcon w="10px" h="10px" sx={{
        opacity: props.sort === SortingTypes.ASC ? 0.6 : 1
      }} />
    </Flex>
  );
}